import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Checkbox, Typography, Tooltip } from 'antd';
import Localization from '../../utils/localization';
import './styles.scss';

const { Title } = Typography;

const ExpansionManagement = ({ isExpansionManagementOpen, handleClose, organization, handleUpdateExpandedPeriods,  highlightedYears = []}) => {
    const [yearsPeriods, setYearsPeriods] = useState(null);
    const [expandedPeriods, setExpandedPeriods] = useState(organization.expanded_periods);
    

    useEffect(() => {
        const numYears = +organization.actuals + organization.budget + organization.forecast;
        const startYear = +organization.starting_year;
        const years = Array.from({ length: numYears }, (_, i) => i + startYear);

        setYearsPeriods(years);
    }, [organization.actuals, organization.budget, organization.forecast, organization.starting_year, setYearsPeriods]);

    useEffect(() => {
        setExpandedPeriods(organization.expanded_periods);
    }, [organization.expanded_periods, setExpandedPeriods]);

    const handleOk = async () => {
        await handleUpdateExpandedPeriods(expandedPeriods);
        
        handleCancel();
      };

    const handleCancel = () => {
        handleClose();
    };

    const onChangeCheckboxMonth = (e) => {
        const index = e.target.index;
        const replacement = e.target.checked ? 'M' : 'Y';
        const newExpandedPeriods = expandedPeriods.replace(/./g, (c, i) => (i === index ? replacement : c));

        setExpandedPeriods(newExpandedPeriods);
    };

    const onChangeCheckboxQuarter = (e) => {
        const index = e.target.index;
        const replacement = e.target.checked ? 'Q' : 'Y';
        const newExpandedPeriods = expandedPeriods.replace(/./g, (c, i) => (i === index ? replacement : c));

        setExpandedPeriods(newExpandedPeriods);
    };

   const renderUnavailable = () => {
        return (
        <div style={{position: 'absolute', left: 0, top: 0, bottom: 0, right: 0, background: 'rgba(0,0,0,0.5)', zIndex: 10, display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', color: 'white', padding: '1rem 1rem'}}>
            <span>Expansion settings unavailable for the moment. Reach out to support for modifications.</span>
        </div>
        );
    }

    const renderExpansionManagementOptions = () => {
        return (
            <div>
                <Row>
                    <Col span={8}>
                        <Title level={3} style={{ marginTop: '10px', marginBottom: '20px' }}>
                            {' '}
                            {Localization.settings.expansionManagementPeriod}{' '}
                        </Title>
                    </Col>
                    <Col span={8}>
                        <Title level={3} style={{ marginTop: '10px', marginBottom: '20px' }}>
                            {' '}
                            {Localization.settings.expansionManagementMonth}{' '}
                        </Title>
                    </Col>
                    <Col span={8}>
                        <Title level={3} style={{ marginTop: '10px', marginBottom: '20px' }}>
                            {' '}
                            {Localization.settings.expansionManagementQuarter}{' '}
                        </Title>
                    </Col>
                </Row>

                {yearsPeriods != null
    ? yearsPeriods.map((period, index) => {
          return (
                <Row
                    key={index}
                    style={{
                        backgroundColor: Array.isArray(highlightedYears) && highlightedYears.includes(index) ? 'rgba(255, 0, 0, 0.1)' : undefined,
                        border: Array.isArray(highlightedYears) && highlightedYears.includes(index) ? '2px solid red' : undefined,
                        borderRadius: '8px',
                        marginBottom: '8px',
                        padding: '8px',
                        transition: '0.3s',
                    }}
              >
                                  <Col span={8}>
                                      <Title level={4}> {period} </Title>
                                  </Col>
                                  <Col span={8}>
                                      <Tooltip title={Localization.settings.expansionManagementCheckboxMonth}>
                                          <Checkbox
                                              index={index}
                                              checked={expandedPeriods[index] === 'M'}
                                              onChange={onChangeCheckboxMonth}
                                          />
                                      </Tooltip>
                                  </Col>
                                  <Col span={8}>
                                      <Tooltip title={Localization.settings.expansionManagementCheckboxQuarter}>
                                          <Checkbox
                                              index={index}
                                              checked={expandedPeriods[index] === 'Q'}
                                              onChange={onChangeCheckboxQuarter}
                                          />
                                      </Tooltip>
                                  </Col>
                              </Row>
                          );
                      })
                    : null}
            </div>
        );
    };

    return (
        <Modal
            bodyStyle={{
                minHeight: '60vh',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative'
            }}
            title={Localization.settings.expansionManagement}
            visible={isExpansionManagementOpen} // not deprecated in our version
            onOk={handleOk}
            confirmLoading={false}
            onCancel={handleCancel} 
        >         
            {renderExpansionManagementOptions()}
        </Modal>
    );
};

export default ExpansionManagement;
